namespace GeniuzPOS.AdvPromo {
    export enum ApprovePromoFgSelect {
        ApproveFgSelect = 0,
        ApproveFgSelect1 = 1,
        WaitFgSelect1 = 2
    }
    Serenity.Decorators.registerEnumType(ApprovePromoFgSelect, 'GeniuzPOS.AdvPromo.ApprovePromoFgSelect');
}
